module.exports = __webpack_public_path__ + "static/media/background.60d0889a.svg";